export default "__VITE_ASSET__8990cfca__"